import {RouteProps} from 'config/navigation';

import DeliveryMen from './delivery-men';
import CreateDeliveryMan from './create-delivery-man';
import {GiFullMotorcycleHelmet} from 'react-icons/gi';
import DeliveryManDetails from './delivery-man-details';

const deliveryMenPages: RouteProps = {
  name: 'Entregadores',
  path: 'delivery-men',
  permission: 'deliveryMen.findAll',
  icon: <GiFullMotorcycleHelmet />,
  subRoutes: [
    {
      path: '',
      element: <DeliveryMen />,
      permissions: ['deliveryMen.findAll'],
    },
    {
      path: 'create',
      element: <CreateDeliveryMan />,
      permissions: ['deliveryMen.findOne'],
    },
    {
      path: ':id',
      element: <DeliveryManDetails />,
      permissions: ['deliveryMen.findOne'],
    },
    {
      path: ':id/motorcycle',
      element: <DeliveryManDetails activeTab="motorcycle" />,
      permissions: ['deliveryMen.findOne'],
    },
  ],
};

export default deliveryMenPages;
